/** @module csi/widget/RefSelectMixin */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/action",
	"csi/comm",
	"csi/store/_base",
], function(declare, _, csiAction, comm, csiStore) {

	return declare(null, {
		/** @property {boolean} multiSelect - indicates if multiple selections are allowed in dialog or not */
		multiSelect: false,

		/**
		 * Return selected urls in widget.
		 * @return {string[]}
		 */
		getWidgetSelections: function() {
			// override in single/multi select widget
			return [];
		},

		/**
		 * Open dialog to select value(s) - defer so select component has time to finish up before opening dialog
		 */
		goToDialog() {
			_.defer(() => {
				const {action} = this.store;
				action.m_preAction = (ac) => this._preActionGoToDialog(ac);
				action.m_postAction = (ac) => this._postActionGoToDialog(ac);
				csiAction.invoke(null, this.domNode, action);
			});
		},

		/**
		 * Return true if target is Go to Dialog
		 * @param {HTMLElement} target
		 * @return {boolean} 
		 */
		isGoToDialogTarget(target) {
			// override in single/multi select widget
			return false;
		},

		/**
		 * Apply selections from the "Go to Dialog" view to the widget
		 * @param {string[]} value
		 */
		setWidgetSelections: function(value) {
			// override in single/multi select widget
		},

		/**
		 * Apply selections from the widget to the "Go to Dialog" view.
		 * @param {Controller} ac - action controller
		 * @return {Deferred}
		 */
		_preActionGoToDialog: function(ac) {
			var fd = ac.getFormData();
			fd.m_bSelectOne = !this.multiSelect;

			var value = this.getWidgetSelections();
			var request = comm.getNodeRequest(value);
			if (!request) {
				return true;
			}

			return request.go().then((response) => {
				response.getResultNodes().forEach((node) => {
					fd.addAggregatedNode(node);
				});
			});
		},

		/**
		 * Post-processing when closing view dialog
		 * @param {Controller} ac - action controller
		 */
		_postActionGoToDialog: function(ac) {
			const formData = ac.getFormData();
			const nodes = formData.getSelectedNodes(true);
			const value = formData.getSelectedValue();
			const store = this.get("store");

			// ensure that any items selected in Go to Dialog are in the store (such as in Delayed Search case);
			// specify before as null to insert it at the end
			nodes.forEach((node) => {
				if (!store.get(node.$URL)) {
					store.put(csiStore.nameObject(node), {before: null});
				}
			});

			// update value of widget
			this.setWidgetSelections(value);
			this.focus();
		},

		/**
		 * @override
		 * Capture Go to Dialog action as early as possible before registering any change to the component
		 */
		_selectOption(target) {
			// NOTE: this does not work for MultiSelect case since it changes the value of the widget in separate event before we ever get here, so
			// need to handle clicking Go to Dialog in _handleOnChange.
			if (this.isGoToDialogTarget(target)) {
				this.closeDropDown();
				this.goToDialog();
			} else {
				this.inherited(arguments);
			}
		}
	});
});